import { Grid, Typography } from '@mui/material';
import HandshakeIcon from '@mui/icons-material/Handshake';
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import SpeedIcon from '@mui/icons-material/Speed';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import React, { useState } from 'react';
import { MandateGeneralDto } from '../../../services/dtos/mandate-general.dto';
import { MandateEstablishmentDto } from '../../../services/dtos/mandate-establishment-dto';
import { MandateTerritoryDto } from '../../../services/dtos/mandate-territory.dto';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import CustomCard from '../../commun/custom-card';
import { FinanceType } from '../../../services/dtos/finances.dto';
import { RelationType } from '../../../services/dtos/relation.dto';
import RequestRelationUi from './request.relation.ui';
import { Sell } from '@mui/icons-material';
import BillsRelationUi from './bills.relation.ui';
import MetersRelationUi from './meters.relation.ui';
import PriceUi from './price.ui';
import GeneralDataRelationUi from './general-data.relation.ui';
import './relation.ui.scss';

type RelationCategory = {
    icon: React.ReactElement;
    text: string;
    type: RelationType;
};

const getRelationCategories = (little: boolean): RelationCategory[] => [
    {
        text: 'Données générales',
        icon: <RecentActorsIcon sx={little ? { fontSize: '5em' } : { fontSize: '9em' }} />,
        type: RelationType.GENERAL,
    },
    {
        text: 'Tarifs',
        icon: <Sell sx={little ? { fontSize: '5em' } : { fontSize: '9em' }} />,
        type: RelationType.PRICE,
    },
    {
        text: 'Demande abonnés',
        icon: <HandshakeIcon sx={little ? { fontSize: '5em' } : { fontSize: '9em' }} />,
        type: RelationType.REQUEST,
    },
    {
        text: 'Indicateurs factures',
        icon: <ReceiptLongOutlinedIcon sx={little ? { fontSize: '5em' } : { fontSize: '9em' }} />,
        type: RelationType.BILLS,
    },
    {
        text: 'Indicateurs relèves',
        icon: <SpeedIcon sx={little ? { fontSize: '5em' } : { fontSize: '9em' }} />,
        type: RelationType.METERS,
    },
];

/**
 * Ui pour les finances
 * @constructor
 */
export default function RelationUi(
    props: Readonly<{
        mandate?: MandateGeneralDto | MandateEstablishmentDto | MandateTerritoryDto;
    }>
) {
    // finance
    const [type, setType] = useState<RelationType | FinanceType>();
    // little
    const [little, setLittle] = useState<boolean>(false);

    /**
     * Mise à jour
     * @param newType
     * @param text
     */
    const handlerSetType = (newType: RelationType | FinanceType | undefined, _text: string | undefined) => {
        setType(newType);
        setLittle(newType !== undefined);
    };
    const categories = getRelationCategories(little);

    const activeContent = (() => {
        switch (type) {
            case RelationType.GENERAL:
                return <GeneralDataRelationUi mandate={props.mandate} type={type} handlerSetType={handlerSetType} />;
            case RelationType.REQUEST:
                return <RequestRelationUi mandate={props.mandate} type={type} handlerSetType={handlerSetType} />;
            case RelationType.BILLS:
                return <BillsRelationUi mandate={props.mandate} type={type} handlerSetType={handlerSetType} />;
            case RelationType.METERS:
                return <MetersRelationUi mandate={props.mandate} type={type} handlerSetType={handlerSetType} />;
            case RelationType.PRICE:
                return <PriceUi mandate={props.mandate} type={type} handlerSetType={handlerSetType} />;
            default:
                return null;
        }
    })();

    //Retourne la vue
    return (
        // Premier container finance
        <Grid container className={'relationUi finances-content'} rowSpacing={1}>
            <Grid item xs={12} md={little ? 6 : 12} className="relationUi__header">
                <Typography variant="h3" className={'relationUi__title title'}>
                    <LocalAtmIcon /> Indicateurs de la relation aux abonnés
                </Typography>
            </Grid>
            {/* Mise en place menu onglet des finances */}
            <Grid item md={little ? 6 : 12} xs={12} className="relationUi__nav">
                {/* Premniere carte */}
                <Grid container className="relationUi__categories" spacing={2} columns={little ? 10 : 12}>
                    {categories.map(category => (
                        <Grid
                            key={category.type}
                            item
                            xs={little ? 5 : 12}
                            sm={little ? 2 : 6}
                            md={little ? 2 : 4}
                            lg={little ? 2 : 2.4}
                            className="relationUi__categoryItem"
                        >
                            <CustomCard
                                little={little}
                                text={category.text}
                                icon={category.icon}
                                type={category.type}
                                handlerSetType={handlerSetType}
                                isSelected={type === category.type}
                                className="relationUi__categoryCard"
                            />
                        </Grid>
                    ))}
                </Grid>
            </Grid>
            {activeContent && (
                <Grid item xs={12}>
                    {activeContent}
                </Grid>
            )}
        </Grid>
    );
}
